import { render, staticRenderFns } from "./AppFoot.vue?vue&type=template&id=09774dc0&scoped=true&"
import script from "./AppFoot.vue?vue&type=script&lang=js&"
export * from "./AppFoot.vue?vue&type=script&lang=js&"
import style0 from "./AppFoot.vue?vue&type=style&index=0&id=09774dc0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09774dc0",
  null
  
)

export default component.exports